// Tools the AI editor hands back to the client instead of running server-side.
// They split in two: browser-preview tools resolve automatically against a
// rendered page and never pause the chat, while user-action tools pause it
// until the user answers.
export const CLIENT_AUTO_RESOLVED_TOOLS: ReadonlySet<string> = new Set([
  "inspectRenderedPage",
  "getPageConsole",
  "interactWithPage",
  "screenshotPage",
]);

export const USER_ACTION_TOOLS: ReadonlySet<string> = new Set([
  "askQuestion",
  "approvePlan",
  "connectStepToApp",
  "connectChatToApp",
  // Retired name; old chats still pause on connector picks recorded under it.
  "connectToApp",
]);
